import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  name: z.string().min(1).max(50),
  color: z.string().min(4).max(9),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  category: {
    id: string;
    name: string;
    color: string;
    position: number | null;
  };
};

export const createTimeCategory = async (
  body: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/time-categories/create`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
